import React, { useEffect, useCallback, useState } from "react";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import { ReactComponent as IconPorcenteNegative } from "../../assets/icons/icon-porcent-negative.svg";
import { ReactComponent as IconPorcentePositive } from "../../assets/icons/icon-porcent-positive.svg";

const MetricCard = ({ app, objectIds, nameCard }) => {
  const [metrics, setMetrics] = useState({
    porcente: null,
    metric01: null,
    metric02: null,
    metric03: null,
  });

  const fetchMetric = useCallback(
    async (key, objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label ?? null;

          setMetrics((prevMetrics) => ({
            ...prevMetrics,
            [key]: value,
          }));
        } catch (error) {
          console.error(`Erro ao buscar ${key} com ID ${objectId}:`, error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app && objectIds) {
      fetchMetric("porcente", objectIds.porcente);
      fetchMetric("metric01", objectIds.metric01);
      fetchMetric("metric02", objectIds.metric02);
      fetchMetric("metric03", objectIds.metric03);
    }
  }, [app, objectIds, fetchMetric]);

  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="flex-start"
      rowGap={2}
    >
      <Grid container className="container-bigNumbers-grafs">
        <Card
          app={app}
          className="card-bigNumbers-grafs card-bigNumbers-graf-01"
        >
          <Grid container className="container-line-current-week">
            <div className="info-current-week">
              <span className="object-number-week">{nameCard}</span>
            </div>

            {metrics.porcente !== null && (
              <div
                className={
                  parseInt(metrics.porcente) > 24
                    ? "info-porcent info-porcent-positive"
                    : "info-porcent info-porcent-negative"
                }
              >
                <span className="icon-arrows">
                  {parseInt(metrics.porcente) > 24 ? (
                    <IconPorcentePositive />
                  ) : (
                    <IconPorcenteNegative />
                  )}
                </span>
                <span className="porcent-info">
                  {metrics.porcente !== null ? metrics.porcente : "Carregando..."}
                </span>
              </div>
            )}
          </Grid>

          <div className="legends-grafs legends-graf-01">
            <p className="container-item-current">
              <span className="item-text">{metrics.metric02}</span>
            </p>
            <p className="container-item-preview">
              <span className="item-text">{metrics.metric01}</span>
            </p>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
};

export default MetricCard;
